import AthleteOnboardingContainer from "@/components/AthleteOnboarding/AthleteOnboardingContainer";

function AthleteOnboardingPage() {
  return <AthleteOnboardingContainer />;
}

export default AthleteOnboardingPage;
